import { createContext, useContext, ReactNode } from 'react'

type SsrPropsContext = { isSsrUserAgentCinchApp?: boolean }

export const SsrPropsContext = createContext<
  { isSsrUserAgentCinchApp?: boolean } | undefined
>(undefined)

const SsrPropsContextProvider = ({
  children,
  isSsrUserAgentCinchApp,
}: {
  children: ReactNode
  isSsrUserAgentCinchApp?: boolean
}) => (
  <SsrPropsContext.Provider value={{ isSsrUserAgentCinchApp }}>
    {children}
  </SsrPropsContext.Provider>
)

const useSsrProps = () => {
  const context = useContext(SsrPropsContext)

  if (context === undefined) {
    throw new Error(
      'useSsrPropsContext must be used within a SsrPropsContextProvider',
    )
  }
  return context
}

export { SsrPropsContextProvider, useSsrProps }
